import ExtraItems from './ExtraItems/ExtraItems'
import NavItems from './NavItems/NavItems'
import NavItemsMob from './NavItems/NavItemsMob'

const Header = () => {
  return (
    <div className="header">
      <NavItemsMob />

      <NavItems />
      <ExtraItems />
    </div>
  )
}

export default Header
